import * as React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {formatHoursAsString} from "../utils";

export default class PercentageLabel extends React.Component{
    render(){
        const {a, b, minutes, label, showPercentage} = this.props;

        if(!a || !b){
            return (<div className="percentage-circle percentage-circle-error">
                <svg viewBox="0 0 32 32" className="percentage-circle-svg" />
            </div>);
        }

        const tooltip = minutes ? (
            <Tooltip id={a + "-" + b}>
                {label} {Math.round(a/b*100)}%<br />
                hours: {formatHoursAsString(a)}<br />
                budget: {formatHoursAsString(b)}
                </Tooltip>
        ) : (
            <Tooltip id={a + "-" + b}>{a} / {b}</Tooltip>
        );

            // <Label bsStyle={a/b<1?"info":"danger"} className="percentage">{Math.round(a/b*100)}%</Label>
        return (
        <OverlayTrigger placement="right" overlay={tooltip}>
            <div className={showPercentage ? "percentage-circle large percentage-circle-with-percentage" : "percentage-circle"}>
                <svg viewBox="0 0 32 32" className="percentage-circle-svg">
                    <circle className="percentage-circle-percentage" r="16" cx="16" cy="16" style={{strokeDasharray: (a / b * 100) + " 100"}}/>
                </svg>
                {showPercentage && (
                    <div>
                        <br />
                        {a > b ? (
                            <span className="percentage-text">{Math.round(a/b*10)/10}x</span>
                        ) : (
                            <span className="percentage-text">{Math.round(a/b*100)}%</span>
                        )}
                    </div>
                )}
            </div>
        </OverlayTrigger>);
    }
}


// WEBPACK FOOTER //
// ./src/components/PercentageLabel.js